/**
 * Sayfa içi yoklama — tarayıcı sekmesi VE paneldeki iç sekme görünürken (2026-10-23).
 *
 * Neden: TabLayout açık iç sekmeleri `display:none` ile bağlı tutar (state korunsun diye). Arkadaki
 * sayfanın setInterval'ı, tarayıcı sekmesi görünür olduğu sürece çalışmaya devam ediyordu; birkaç iç
 * sekme açık bırakan kullanıcı hepsinin yoklamasını aynı anda yapıyordu. gorunurAralik yalnız
 * tarayıcı sekmesine bakar; bu hook iç sekmeye de bakar.
 *
 * useYoklama(fn, ms, { gizliMs, aktif }):
 *   · iç sekme aktif + tarayıcı sekmesi görünür → ms'de bir fn
 *   · arkadayken gizliMs'de bir (null → hiç)
 *   · öne gelince (iç sekme ya da tarayıcı) hemen bir kez tazeler
 *   · aktif=false → hiç çalışmaz (ör. modal kapalı)
 * fn her render'da yenilenebilir; zamanlayıcı yeniden kurulmaz (son fn çağrılır).
 */
import { createContext, useContext, useEffect, useRef } from 'react';

// TabLayout her iç sekmeyi bununla sarar; sekme sistemi dışındaki sayfalarda varsayılan true
export const SekmeAktifContext = createContext(true);
export const useSekmeAktif = () => useContext(SekmeAktifContext);

export function useYoklama(fn, ms, { gizliMs = null, aktif = true } = {}) {
  const sekmeAktif = useSekmeAktif();
  const fnRef = useRef(fn);
  fnRef.current = fn;
  const sonRef = useRef(0);
  const oncekiSekmeRef = useRef(sekmeAktif);

  // İç sekme öne gelince bekletmeden tazele (tarayıcı sekmesindeki davranışla aynı)
  useEffect(() => {
    const onceki = oncekiSekmeRef.current;
    oncekiSekmeRef.current = sekmeAktif;
    if (aktif && sekmeAktif && !onceki && Date.now() - sonRef.current > 2000) {
      sonRef.current = Date.now();
      try { fnRef.current(); } catch { /* çağıran kendi hatasını yönetir */ }
    }
  }, [sekmeAktif, aktif]);

  useEffect(() => {
    if (!aktif || !ms) return undefined;
    const calis = () => {
      sonRef.current = Date.now();
      try { fnRef.current(); } catch { /* çağıran kendi hatasını yönetir */ }
    };
    const gizli = () => (typeof document !== 'undefined' && document.hidden) || !sekmeAktif;
    const t = setInterval(() => {
      if (!gizli()) calis();
      else if (gizliMs && Date.now() - sonRef.current >= gizliMs - 50) calis();
    }, ms);
    const gorunurlukDegisti = () => {
      if (!gizli() && Date.now() - sonRef.current > 2000) calis();
    };
    document.addEventListener('visibilitychange', gorunurlukDegisti);
    return () => {
      clearInterval(t);
      document.removeEventListener('visibilitychange', gorunurlukDegisti);
    };
  }, [ms, gizliMs, aktif, sekmeAktif]);
}

export default useYoklama;
